<template>
    <div class="message_send" :style="screenHeight">
      <div class="message_send_input">
        <div class="font_style_set"><span style="color: red">*</span>接收手机号:</div>
        <Input v-model="telPhone" class="input_content" type="textarea" :rows="4" :autosize="{minRows: 4}"   placeholder="请输入接收手机号"/>
        <div class="title_font" style="line-height: 80px;">多个手机号可用英文","隔开,如:15000000000,18000000000,19000000000</div>
      </div>
      <div class="font_style"></div>
      <div class="message_send_input" style="height: 50px;line-height: 50px">
        <div class="font_style_set" style="padding-top: 0px">短信模板:</div>
        <Select v-model="msgTemplate" placeholder="请选择发送模板" clearable title="发送模板" @on-change="handleTemplate">
          <Option v-for="(option, index) in msgTemplateList" :value="option.id" :key="index">{{option.tittle}}</Option>
        </Select>
        <div style="display: none" class="title_font">更多模板可在系统管理==>基本配置==>短信服务商设置中配置</div>
      </div>
      <div class="message_send_input" style="margin-top: 20px;">
        <div class="font_style_set"><span style="color: red">*</span>发送内容:</div>
        <Input v-model="content" class="input_content" type="textarea" :rows="4" :autosize="{minRows: 4}"  placeholder="请输入发送内容" @on-change="getCount"/>
        <div class="title_font" style="line-height: 80px;">已输入{{fontCount}}字符,共{{noteCount}}条短信</div>
      </div>
      <div class="btn_template">
        <Button type="primary"  @click="sendMessage()">发送</Button>
      </div>
    </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "MessageSend",
      mixins:[publicFunClass],
      props:{
        pageCode:String
      },
      data(){
        return {
          showPageCount:0,
          screenHeight:{height:''},
          telPhone:'',
          fontCount:'0',
          noteCount:'0',
          content:'',
          msgTemplate:'',
          msgTemplateList:[],
          questionMark:require('../../assets/image/homeAsk.png')
        }
      },
      methods:{
        getCount:function(){
          if(!this.content){
            this.fontCount="0";
            this.noteCount="0";
            return false;
          }
          let length=parseInt(this.content.length);
          this.fontCount=length;
          this.noteCount=Math.ceil(parseInt(length)/70);
        },
        handleTemplate:function(){
          for(let i=0;i<this.msgTemplateList.length;i++){
            let id=this.msgTemplateList[i].id;
            let content=this.msgTemplateList[i].content;
            if(id==this.msgTemplate){
                this.content=content;
            }
          }
        },
        sendMessage:function () {
          let that=this;
          if(!this.telPhone){
            this.$Message.info("接收号码不能为空");
            return false;
          }
          let reg=/^[0-9]*$/;
          let phoneList=this.telPhone.split(",");
          for (let i=0;i<phoneList.length;i++){
            let phone=phoneList[i];
            if(!reg.test(phone)){
              this.$Modal.info({
                title:'提示',
                content:"接收号码必须是数字"
              });
              return false;
            }
          }
          if(!this.content){
            this.$Message.info("发送内容不能为空");
            return false;
          }
          let param={
            telphone:this.telPhone,
            content:this.content,
            msgTemplate:this.msgTemplate,
            journalType:"短信管理=>发送短信",
            menuId:"null"
          };
          this.$http.post("message/doSend.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("短信发送成功");
          });
        },
        initSearch:function () {
          let that=this;
          let param={
            tittle:"",
            createTime:"",
            pageNum:"",
            pageSize:"",
            journalType:"null",
            menuId:"null"
          };
          this.$http.post("message/toTemplateIndex.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.msgTemplateList=res.data.obj.list.content;
          });
        }
      },
      created(){
        this.screenHeight.height=this.mountHeight(91);
      },
      watch:{
        pageCode:function () {
          if(this.pageCode=='5_2' && this.showPageCount==0){
            this.showPageCount++;
            this.initSearch();
          }
        },
        content:function () {
          this.getCount();
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MessageManage/MessageSend.vue